import React from "react";
import MainPage from "../Pages/MainPage/MainPage";

//const CompName = React.lazy(() => import("CompName"));

const baseRoutes = [
  {
    path: "*",
    element: <MainPage />,
  },
  {
    path: "/",
    element: <MainPage />,
  },
];
export default baseRoutes;
